import Vue from 'vue';
import CustomValidator from '@/Validator';
import { ver } from '@/ver.json';
import Root from './Root.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import '@fortawesome/fontawesome-free/css/all.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';

console.log(`ver. ${ver}`);

Vue.config.productionTip = false;

Vue.use(new CustomValidator());

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(Root),
}).$mount('#app');
